import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseService} from './base.service';
import {ApiResponse} from '../model/api-response';
import {Organization} from '../model/organization';
import {OrganizationMembership} from '../model/organization-membership';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService extends BaseService {
  httpClient: HttpClient = inject(HttpClient);

  constructor() {
    super();
  }

  getAllOrganizations(includeInactive: boolean = false): Observable<ApiResponse<Array<Organization>>> {
    const params = includeInactive ? { includeInactive: 'true' } : undefined;
    return this.httpClient.get<ApiResponse<Array<Organization>>>(`${this.baseUrl}/organizations`, { params });
  }

  getMyOrganizations(): Observable<ApiResponse<Array<Organization>>> {
    return this.httpClient.get<ApiResponse<Array<Organization>>>(`${this.baseUrl}/organizations/mine`);
  }

  getOrganizationById(id: number): Observable<ApiResponse<Organization>> {
    return this.httpClient.get<ApiResponse<Organization>>(`${this.baseUrl}/organizations/${id}`);
  }

  createOrganization(organization: Organization): Observable<ApiResponse<Organization>> {
    return this.httpClient.post<ApiResponse<Organization>>(`${this.baseUrl}/organizations`, organization);
  }

  updateOrganization(id: number, organization: Organization): Observable<ApiResponse<Organization>> {
    return this.httpClient.patch<ApiResponse<Organization>>(`${this.baseUrl}/organizations/${id}`, organization);
  }

  deleteOrganization(id: number): Observable<ApiResponse<string>> {
    return this.httpClient.delete<ApiResponse<string>>(`${this.baseUrl}/organizations/${id}`);
  }

  getOrganizationMembers(orgId: number): Observable<ApiResponse<Array<OrganizationMembership>>> {
    return this.httpClient.get<ApiResponse<Array<OrganizationMembership>>>(`${this.baseUrl}/organizations/${orgId}/members`);
  }

  /** Aggiunge un membro tramite email esatta dell'utente */
  addOrganizationMember(orgId: number, email: string, role: string): Observable<ApiResponse<OrganizationMembership>> {
    return this.httpClient.post<ApiResponse<OrganizationMembership>>(
      `${this.baseUrl}/organizations/${orgId}/members`,
      { email, role }
    );
  }

  /** Aggiorna il ruolo: `userId` è il profile id (user_profile.id) restituito da GET /members */
  updateOrganizationMemberRole(orgId: number, userId: number, role: string): Observable<ApiResponse<OrganizationMembership>> {
    return this.httpClient.patch<ApiResponse<OrganizationMembership>>(
      `${this.baseUrl}/organizations/${orgId}/members/${userId}?role=${encodeURIComponent(role)}`,
      null
    );
  }

  /** Rimuove un membro: `userId` è il profile id (user_profile.id) restituito da GET /members */
  removeOrganizationMember(orgId: number, userId: number): Observable<ApiResponse<string>> {
    return this.httpClient.delete<ApiResponse<string>>(`${this.baseUrl}/organizations/${orgId}/members/${userId}`);
  }
}
